type PostPdfReportUrlOptions = {
    apiUrl: string;
    postId: number;
    scoreId: number | string;
    organizationId: number | null;
};

export const buildPostPdfReportUrl = (options: PostPdfReportUrlOptions): string => {
    const { apiUrl, postId, scoreId, organizationId } = options;

    const params = new URLSearchParams({ scoreId: String(scoreId) });
    if (organizationId !== null) {
        params.set("organization_id", String(organizationId));
    }

    return `${apiUrl}/api/ssq-posts/${postId}/pdf-report?${params.toString()}`;
};
